export default __webpack_public_path__ + "static/media/workManagement.73d02023.png";